import React from 'react'
import styled from 'styled-components'
import { FormRow, FormInputLabel } from '@appearance/styled'
import i18n from '@localization/i18n'

export default () => {
    return (
        <FormRow>
            <StyledFormInputLabel>
                <Red> * </Red>
                {i18n.t('edit_dance.required_fields')}
            </StyledFormInputLabel>
        </FormRow>
    )
}

const StyledFormInputLabel = styled(FormInputLabel)`
    padding: 10px 20px;
`
const Red = styled.span`
    color: red;
`
